import ComisionUpdate from './ComisionUpdate'
export {ComisionUpdate}
export default ComisionUpdate
